import { render } from "./SimpleTreeItem.vue?vue&type=template&id=0c105dbb&scoped=true"
import script from "./SimpleTreeItem.vue?vue&type=script&lang=js"
export * from "./SimpleTreeItem.vue?vue&type=script&lang=js"

import "./SimpleTreeItem.vue?vue&type=style&index=0&id=0c105dbb&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0c105dbb"

export default script